// NOMA SEO/GEO: builds a table of contents by scanning the rendered article body for <h2>
// elements, auto-assigning ids where missing, and listing them as jump links.
// Deliberately does this in JS against the rendered DOM rather than hand-parsing HTML in
// Liquid, which is fragile. Added 2026-08-18.
(function () {
  function slugify(text, used) {
    var base = (text || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-+|-+$)/g, '');
    if (!base) base = 'section';
    var id = base;
    var n = 1;
    while (used[id] || document.getElementById(id)) {
      id = base + '-' + n;
      n += 1;
    }
    return id;
  }

  function buildToc() {
    var toc = document.querySelector('[data-seo-geo-toc]');
    if (!toc) return;

    var list = toc.querySelector('[data-seo-geo-toc-list]');
    if (!list) return;

    var body = document.querySelector('.blog-post-content');
    if (!body) return;

    var headings = body.querySelectorAll('h2');
    if (!headings.length) return;

    var used = {};
    var fragment = document.createDocumentFragment();

    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent, used);
      }
      used[heading.id] = true;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      fragment.appendChild(li);
    });

    list.appendChild(fragment);
    toc.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
